module.exports = __webpack_public_path__ + "static/media/zoom-minus.203878c3.svg";